import React from 'react';
import ReactSelect, { IndicatorProps, OptionProps, Props as SelectProps, components as select } from 'react-select';

// @ts-expect-error - React Select type constraints are too strict
export function DropdownIndicator<T, b extends boolean>(props: IndicatorProps<T, b>) {
  let innerProps = {
    'aria-label': 'Open dropdown',
    'data-cy': 'dropdown-indicator',
    ...props.innerProps,
  };
  // @ts-expect-error - React Select type constraints are too strict
  return <select.DropdownIndicator {...props} innerProps={innerProps} />;
}

// @ts-expect-error - React Select type constraints are too strict
export function Option<T, b extends boolean>(props: OptionProps<T, b>) {
  let innerProps = {
    'data-cy': 'select-option',
    'data-testid': 'select-option',
    ...props.innerProps,
  };
  // @ts-expect-error - React Select type constraints are too strict
  return <select.Option {...props} innerProps={innerProps} />;
}

// @ts-expect-error - React Select type constraints are too strict
export function Select<OptionType, IsMulti extends boolean = false>(props: SelectProps<OptionType, IsMulti>) {
  let { components, ...rest } = props;
  // @ts-expect-error - React Select type constraints are too strict
  return <ReactSelect<OptionType, IsMulti> {...rest} components={{ DropdownIndicator, Option, ...components }} />;
}
